import { useContext, useEffect, useRef, useState } from "react";
import axios from "./API/axios";
import AuthContext from "./Context/AuthProvider";
import {
  Card,
  CardContent,
  Grid2,
  Link,
  TextField,
  Typography,
  Button,
  InputLabel,
  FormControl,
  Alert,
  Collapse,
  IconButton,
  Box,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { saveAuth } from "./Utility/AuthManager";
import { useSnackbar } from "./Utility/UserMessageContext";
import { forgotPassword } from "./API/LoginApi";
import { showSmallLoadingImage } from "./Utility/Utility";

function Login() {
  const { setAuth } = useContext(AuthContext);
  const [authToken, setAuthToken] = useState();
  const [userFullName, setUserFullName] = useState();
  const [userRoles, setUserRoles] = useState();
  const userRef = useRef();
  //const errRef = useRef();
  const [userName, setUserName] = useState();
  const [password, setPassword] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [emailError, setEmailError] = useState("");
  const LOGIN_URL = "/api/account/login";
  const FACILITY_URL = "/api/facility";
  const [associatedFacilities, setAssociatedFacilities] = useState();
  const [selectedFacilityId, setSelectedFacilityId] = useState();
  const [showFacilitySelectionDialog, setShowFacilitySelectionDialog] =
    useState();
  const [showPassword, setShowPassword] = useState();
  const [waiting, setWaiting] = useState(false);
  const { showSnackbar } = useSnackbar();
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  const [forgotPasswordEmailError, setForgotPasswordEmailError] = useState("");

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Check if user is facility admin
  

  // useEffect(() => {
  //   userRef.current.focus();
  //   localStorage.clear();

  // }, []);

  // useEffect(() => {
  //   setErrorMessage("");
  // }, [userName, password]);

  const onFacilitySelection = () => {
    var selectedFacility = associatedFacilities.find(
      (a) => a.id === selectedFacilityId
    );
    const authData = { 
      userName, 
      authToken: authToken, 
      selectedFacility, 
      userFullName, 
      roles: userRoles,
      associatedFacilities: associatedFacilities,
    };
    setAuth(authData);
    saveAuth(authData);
  };

  const getUsersFacilities = async (uName, token, fullName, roles) => {
    var selectedFac = null;
    await axios
      .get(FACILITY_URL + "/my", {
        headers: { Authorization: "Bearer " + token },
      })
      .then(
        (selectedFac = function (response) {
          setAssociatedFacilities(response?.data);
          if (response.data.length === 1) {
            const authData = {
              userName: uName,
              userFullName: fullName,
              authToken: token,
              selectedFacility: response?.data[0],
              roles: roles,
              associatedFacilities: response?.data,
              //isFacilityAdmin: isFacilityAdmin(roles)
            };
            setAuth(authData);
            saveAuth(authData);
          } else if (response.data.length > 1) {
            // var facilityModal = new Modal(
            //   document.getElementById("chooseFacilityModal")
            // );
            // facilityModal.show();
            setShowFacilitySelectionDialog(true);
          } else {
            showSnackbar("No facilities are associated with user.", "error");
            //setShowAlert(true);
          }
        })
      )
      .catch(function (error) {
        if (!error.response) {
          showSnackbar(
            "No response is received from the server for facilities.",
            "error"
          );
        } else {
          showSnackbar(
            "Error occurred while getting the facilities details for the user.",
            "error"
          );
        }
        //setShowAlert(true);
        //errRef.current.focus();
      });
    return selectedFac;
  };

  const onClick = async (e) => {
    e.preventDefault();
    
    // Validate email before proceeding
    if (!validateEmail(userName)) {
      setEmailError("Please enter a valid email address");
      showSnackbar("Please enter a valid email address", "error");
      return;
    }
    
    setEmailError("");
    setWaiting(true);
    setErrorMessage();
    
    await axios
      .post(
        LOGIN_URL,
        { userName: userName, password: password },
        {
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      )
      .then(async function (response) {
        const fullName =
          response?.data?.prefix +
          " " +
          response?.data?.firstName +
          " " +
          response?.data?.lastName;
        setUserFullName(fullName);
        setAuthToken(response?.data?.token);
        setUserRoles(response?.data?.roles);
        
        // console.log("Login Response - User Roles:", response?.data?.roles);
        // console.log("Is Facility Admin:", isFacilityAdmin(response?.data?.roles));
        
        await getUsersFacilities(
          response?.data?.userName,
          response?.data?.token,
          fullName,
          response?.data?.roles
        );
        setPassword("");
        setWaiting(false);
      })
      .catch(function (error) {
        if (!error.response) {
          showSnackbar("No response is received from the server.", "error");
        } else {
          showSnackbar(error?.response?.data, "error");
        }
        setWaiting(false);
        //setShowAlert(true);
        //errorToast.show();
        //errRef.current.focus();
      });
  };

  const handleForgotPasswordClick = () => {
    setForgotPasswordEmail("");
    setForgotPasswordEmailError("");
    setShowForgotPassword(true);
  };

  const handleCloseForgotPassword = () => {
    setShowForgotPassword(false);
  };

  const handleSendForgotPasswordEmail = async () => {
    // Validate email before sending password reset
    if (!validateEmail(forgotPasswordEmail)) {
      setForgotPasswordEmailError("Please enter a valid email address");
      showSnackbar("Please enter a valid email address", "error");
      return;
    }
    
    setForgotPasswordEmailError("");
    setWaiting(true);
    
    // Implement the logic to send the forgot password email
    var result = await forgotPassword(forgotPasswordEmail);
    if (result.isSuccess) {
        showSnackbar('Password reset link has been sent to your email.', 'success');
        setShowForgotPassword(false);
    } else {
        showSnackbar("Error sending password reset link: " + result.data, "error");
    }
    setWaiting(false);
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setUserName(email);
    if (email && !validateEmail(email)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleForgotPasswordEmailChange = (e) => {
    const email = e.target.value;
    setForgotPasswordEmail(email);
    if (email && !validateEmail(email)) {
      setForgotPasswordEmailError("Please enter a valid email address");
    } else {
      setForgotPasswordEmailError("");
    }
  };

  return (
    <>
      <Grid2 container sx={{ height: "100vh", width: "100vw" }}>
        <Grid2
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            backgroundImage: "url(./Banner1.jpg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.4,
          }}
        ></Grid2>
        <Grid2
          container
          size={12}
          sx={{
            position: "relative",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card
            variant="outlined"
            sx={{
              height: "400px",
              width: "400px",
              alignContent: "center",
              justifyContent: "center",
              zIndex: 1,
            }}
          >
            <Grid2
              container
              size={12}
              sx={{
                justifyContent: "center",
                alignItems: "center",
                paddingX: "25px",
              }}
              spacing={3}
            >
              <Typography fullWidth variant="h5" gutterBottom>
                Sign In
              </Typography>
              <FormControl fullWidth>
                {/* Username Field with email validation */}
                <TextField
                  label="Email"
                  variant="outlined"
                  slotProps={{ inputLabel: { shrink: true } }}
                  fullWidth
                  onChange={handleEmailChange}
                  required
                  value={userName}
                  disabled={waiting}
                  error={!!emailError}
                  helperText={emailError}
                />
              </FormControl>
              <FormControl fullWidth>
                {/* Password Field */}
                <TextField
                  label="Password"
                  slotProps={{
                    inputLabel: { shrink: true },
                    input: {
                      endAdornment: (
                        <InputAdornment>
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            onMouseDown={(e) => e.preventDefault()}
                            edge="end"
                          >
                            {showPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  value={password}
                  disabled={waiting}
                />
              </FormControl>
              {/* Sign In Button */}
              <Button
                variant="contained"
                fullWidth
                color="secondary"
                onClick={(e) => onClick(e)}
                disabled={waiting}
              >
                Sign In
              </Button>

              <Link
                href="#"
                variant="body2"
                sx={{ marginTop: "20px" }}
                onClick={handleForgotPasswordClick}
              >
                Forgot Password?
              </Link>
            </Grid2>
          </Card>
        </Grid2>
      </Grid2>
      <Dialog open={showForgotPassword} onClose={handleCloseForgotPassword}>
        <DialogTitle>Forgot Password</DialogTitle>
        <DialogContent dividers>
        <Grid2 container size={12} spacing={2}>
           <Typography>
              Please enter your email address to receive a password reset link.
            </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="Email Address"
            type="email"
            fullWidth
            variant="outlined"
            value={forgotPasswordEmail}
            onChange={handleForgotPasswordEmailChange}
            disabled={waiting}
            error={!!forgotPasswordEmailError}
            helperText={forgotPasswordEmailError}
          />
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseForgotPassword} variant="outlined" disabled={waiting}
            color="inherit">
            Cancel
          </Button>
          <Button onClick={handleSendForgotPasswordEmail} variant="contained" disabled={waiting}
            color="secondary">
              {waiting && showSmallLoadingImage()}
            Send
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={showFacilitySelectionDialog}>
        <DialogTitle>Select Facility</DialogTitle>
        <DialogContent dividers>
          <Grid2 container size={12} spacing={2}>
            <Typography>
              You are associated with more than one facilities. Please select
              one to proceed.
            </Typography>
            <FormControl fullWidth>
              <InputLabel>Select Facility</InputLabel>
              <Select
                label="Select Facility"
                value={selectedFacilityId}
                onChange={(e) => {
                  setSelectedFacilityId(e.target.value);
                }}
              >
                {associatedFacilities?.map((i) => (
                  <MenuItem value={i.id}>
                    {i.name}, {i.addressLine2}, {i.city}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowFacilitySelectionDialog(false)}
            variant="outlined"
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setShowFacilitySelectionDialog(false); // Close the dialog
              onFacilitySelection();
            }}
            variant="contained"
            color="secondary"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <div
        class="modal fade"
        id="chooseFacilityModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="staticBackdropLabel">
                Select Facility
              </h5>
            </div>
            <div class="modal-body">
              <label>
                You are associated with more than one facilities. Please select
                one to proceed.
              </label>
              <select
                class="form-select form-select-sm  border-secondary mt-2 p-2"
                name=""
                id="facilitySelector"
              >
                {associatedFacilities?.map((i) => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </select>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={onFacilitySelection}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;